import { BaseEntity } from '../../interfaces';

export class EditableEntityDto<T extends BaseEntity> {
  uuid?: string;

  constructor(entity: T | undefined) {
    this.uuid = entity?.uuid;
  }
}
